import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NotificationEditData } from './notification-edit-data.model';

@Component({
	selector: 'notification-edit-feild',
	templateUrl: 'notification-edit-feild.component.html'
})
export class NotificationEditFeildComponent implements OnChanges {
	@Input() context: any;
	@Input() nightMode: boolean;
	@Input() destinationToStorage: boolean
	@Output() cpDateChanged = new EventEmitter<any>();
	@Output() requestRecieverForm = new EventEmitter<any>();
	public isRequestRecieverForm = true;
	public currentDate = new Date();


	constructor() {	}

	ngOnChanges(changes: SimpleChanges) {
	}

	dateChanged(): void {
		this.cpDateChanged.emit(this.context);
	}
	
	changeRequestReview(value:boolean){
		this.isRequestRecieverForm = value;
		this.requestRecieverForm.emit(value);
	}
}
